import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
import { TaxonomyType } from '@stereoagency/constants';
import taxonomy from '../documents/taxonomy.js';
import arrayEntry from '../fragments/arrayEntry.js';
import sanityReference from '../fragments/sanityReference.js';
var schema = defineObject('researchGroupListingSection', {
    enableTaxonomyFilter: {
        title: 'Enable taxonomy filter (user selectable)',
        type: 'boolean'
    },
    staticFilter: {
        title: 'Static filter (only show matching entries)',
        type: 'array',
        of: [
            {
                type: 'reference',
                to: [
                    {
                        type: 'taxonomy'
                    }
                ],
                options: {
                    filter: 'type in $types',
                    filterParams: {
                        types: [
                            TaxonomyType.DISEASE_AREA,
                            TaxonomyType.LAB
                        ]
                    }
                }
            }
        ]
    },
    title: {
        type: 'string',
        title: 'Title'
    },
    subtitle: {
        type: 'string',
        title: 'Subtitle'
    }
}, [
    taxonomy.schema.taxonomy
]);
var validator = z.object({
    enableTaxonomyFilter: z.boolean(),
    staticFilter: z.array(sanityReference.validator.merge(arrayEntry.validator)),
    title: z.string(),
    subtitle: z.string()
}).partial();
schema.researchGroupListingSection;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=researchGroupListingSection.js.map